import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import { useComplianceContext } from "context/ComplianceContext";
import StatusBadge from "./StatusBadge";
import ComplianceAccessGate from "./ComplianceAccessGate";

const filters = [
  { key: "overdue", label: "Overdue Tasks" },
  { key: "today", label: "Due Today" },
  { key: "thisWeek", label: "Due this Week" },
  { key: "nextWeek", label: "Due next Week" },
  { key: "thisMonth", label: "Due this Month" },
  { key: "nextMonth", label: "Due next Month" },
  { key: "thisQuarter", label: "Due this Quarter" },
  { key: "nextQuarter", label: "Due next Quarter" },
];

const formatDate = (value) => {
  if (!value) return "—";
  try {
    return format(parseISO(value), "dd MMM yyyy");
  } catch (error) {
    return value;
  }
};

const ComplianceTasksBoard = () => {
  const { getTasksByFilter } = useComplianceContext();
  const [activeFilter, setActiveFilter] = useState(filters[0].key);

  const tasks = getTasksByFilter(activeFilter);

  return (
    <ComplianceAccessGate>
      <div className="space-y-6">
        <header>
          <h1 className="text-3xl font-semibold text-gray-900">
            Compliance Tasks Board
          </h1>
          <p className="mt-2 text-sm text-gray-600">
            Quick filters for Registrar to view tasks by urgency across all
            corporates and companies.
          </p>
        </header>
        <div className="flex flex-wrap gap-2">
          {filters.map((filter) => (
            <button
              key={filter.key}
              type="button"
              onClick={() => setActiveFilter(filter.key)}
              className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                activeFilter === filter.key
                  ? "bg-sflPrimary text-white"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
            >
              {filter.label}
            </button>
          ))}
        </div>
        <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 text-left text-sm">
              <thead className="bg-gray-50 text-xs uppercase tracking-wide text-gray-500">
                <tr>
                  <th className="px-4 py-3">Entity</th>
                  <th className="px-4 py-3">Category</th>
                  <th className="px-4 py-3">Task</th>
                  <th className="px-4 py-3">Responsibility</th>
                  <th className="px-4 py-3">Deadline</th>
                  <th className="px-4 py-3">Status</th>
                  <th className="px-4 py-3">Compliance</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {tasks.length === 0 ? (
                  <tr>
                    <td
                      className="px-4 py-4 text-center text-sm text-gray-500"
                      colSpan={6}
                    >
                      No tasks match the selected filter.
                    </td>
                  </tr>
                ) : (
                  tasks.map((task) => (
                    <tr key={task.id} className="hover:bg-gray-50">
                      <td className="px-4 py-3 font-semibold text-gray-800">
                        <span className="block text-xs font-normal uppercase tracking-wide text-gray-500">
                          {task.entityLabel}
                        </span>
                        <span>{task.corporateName}</span>
                      </td>
                      <td className="px-4 py-3 text-gray-700">
                        {task.categoryName}
                      </td>
                      <td className="px-4 py-3 text-gray-700">{task.title}</td>
                      <td className="px-4 py-3 text-gray-600">
                        {(task.responsibilities || [])
                          .map(
                            (responsibility) =>
                              responsibility.initials ||
                              responsibility.name ||
                              "Unassigned"
                          )
                          .join(", ") || "Unassigned"}
                      </td>
                      <td className="px-4 py-3 text-gray-600">
                        {formatDate(task.deadline)}
                      </td>
                      <td className="px-4 py-3 text-gray-700">
                        {task.statusLabel}
                      </td>
                      <td className="px-4 py-3">
                        <StatusBadge statusKey={task.summaryStatus} />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </ComplianceAccessGate>
  );
};

export default ComplianceTasksBoard;
